import dayjs from 'dayjs';
import IDropdownReference from '../../utils/types/IDropdownReference';

export const NotificationStatus = {
  Read: 'Read',
  Unread: 'Unread',
  Deleted: 'Deleted',
} as const;

export type NotificationStatusType = (typeof NotificationStatus)[keyof typeof NotificationStatus];

/** A notification as displayed in the header notification panel. */
export interface IStatNotificationItem {
  itemKey: string;
  title: string;
  description: string;
  timestamp: Date;
  notificationStatus: NotificationStatusType;
}

export interface IStatNotification {
  id?: number;
  header: string;
  content: string;
  ordinal?: number;
  startDate?: Date;
  endDate?: Date;
  createdDate?: Date;
  notificationType: IDropdownReference;
}

export interface Toast {
  className?: string;
  id: number;
  header?: string;
  content: string;
  iconName?: string;
}

export enum NotificationType {
  Panel = 'Panel',
  Dashboard = 'Dashboard',
  Banner = 'Banner',
  DismissibleBanner = 'Banner (dismissible)',
}

export const mapToNotificationItems = (
  notifications: IStatNotification[],
): IStatNotificationItem[] => {
  const now = new Date();

  return notifications
    .filter(
      (notification) =>
        now >= new Date(notification.startDate) && now <= new Date(notification.endDate),
    )
    .map((notification: IStatNotification) => ({
      itemKey: notification?.id.toString(),
      notificationStatus: NotificationStatus.Unread,
      timestamp: dayjs(notification.createdDate).toDate(),
      description: notification.content,
      title: notification.header,
    }));
};
